module.exports = __webpack_public_path__ + "media/v1.dd48f8db.mp4";